// extracted by mini-css-extract-plugin
export default {"root":"StoryType__root--19HET","root_small":"StoryType__root_small--10KsF","root_short":"StoryType__root_short--2g8M6","text":"StoryType__text--3K5s_"};